export const languages = [
    {name: 'Français', localeId: 'en-US'},
    {name: 'العربية', localeId: 'ar'},
];

export const APP_BROWSER_SESSION_KEYNAME = 'browserKeyPortailCPPF';

export enum Genre {
    HOMME = 1,
    FEMME = 2,
}

export enum TypeReclamation {
    TITRE = 1,
    ORDRE_GENERALE = 2
}

export enum TypeTitre {
    PASSEPORT = 1,
    CNI = 2,
    SEJOUR = 3,
}

export enum TypeMotifCNI {
    PERTE = 1,
    VOL = 2,
    DETERIORATION = 3,
    AUTRE = 4,
}

export enum TypeSituation {
    MARIE = 1,
    CELIBATAIRE = 2,
    DIVORCE = 3,
    VEUF = 4,
    CONCUBINAGE = 5
}

export enum Fonction {
    Fonctionnaire = 1,
    Entrepreneur = 2,
    Ouvrier = 3,
    Etudiant = 4,
    EmployeSecteurPublic = 5,
    EmployeSecteuPrive = 6,
    EnRechercheEmploiOuSansEmploi = 7,
    ProfessionLiberale = 8,
    Autre = 9
}

export enum Statut {
    Civil = 1,
    Militaire = 2
}

export enum Pays {
    Gabon = 1
}

export const MSG_SUCCESS = 'Traitement effectué avec succès';
export const MSG_SUCCESS_DEL = 'Elément supprimé avec succès';
export const MSG_ERROR = 'Problème survenu durant le traitement';

// Les thèmes de GFX
export const GFX_THEME: 'vuely' | 'light' = 'light';

export const FINGERPRINT_KEY = 'x_ident';
